import type { CapabilitySuggestion } from '@indutrust/capability-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Events driving the factory-scoped
 * {@link import('./capability-suggestion.store').CapabilitySuggestionStore}.
 *
 * @example
 * const dispatch = injectDispatch(capabilitySuggestionEvents);
 * dispatch.loadRequested({ factoryId: 7 });
 */
export const capabilitySuggestionEvents = eventGroup({
  source: 'capability.suggestion',
  events: {
    loadRequested: type<{ factoryId: number }>(),
    loadSucceeded: type<{
      factoryId: number;
      suggestions: CapabilitySuggestion[];
    }>(),
    loadFailed: type<{ error: string }>(),

    addRequested: type<{
      factoryId: number;
      kind: CapabilitySuggestion['kind'];
      name: string;
      description?: string;
      /** Required when {@link CapabilitySuggestion.kind} is `'leaf'`. */
      parentId?: number;
      /** Set when dual-writing from a machine-park save. */
      machineParkId?: number;
    }>(),
    addSucceeded: type<{ suggestion: CapabilitySuggestion }>(),
    addFailed: type<{ error: string }>(),
  },
});
